import React from 'react';
import Select from '../ui/Select';
import Input from '../ui/Input';
import { PROPERTY_OPS } from '../../data/events';
import { segmentService } from '../../services/segmentService';
import MultiValueInput from './MultiValueInput';
import styles from './FilterRow.module.css';

let _propId = 0;
export function nextPropId() {
  return ++_propId;
}

// The "where propName op value [and …]" editor for an event's arbitrary
// per-event properties — extracted out of FilterRow so the Journey
// Builder's Event Trigger gets the exact same live-autocomplete property
// filter the Segment Builder's event filter already has, instead of a
// second implementation.
class PropertyFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = { eventProps: [] };
  }

  componentDidMount() {
    this._load(this.props.eventName, this.props.eventTable, this.props.entityType);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.eventName !== this.props.eventName
      || prevProps.eventTable !== this.props.eventTable
      || prevProps.entityType !== this.props.entityType
    ) {
      this._load(this.props.eventName, this.props.eventTable, this.props.entityType);
    }
  }

  // entityType is the earning condition's alternate key — earning_events has
  // no meaningful event_name to key sample discovery off (see FilterRow.jsx).
  _load(eventName, eventTable, entityType) {
    if (!eventName && !entityType) { this.setState({ eventProps: [] }); return; }
    segmentService.getEventProperties(eventTable || 'events', eventName, entityType)
      .then((eventProps) => this.setState({ eventProps }))
      .catch(() => this.setState({ eventProps: [] }));
  }

  render() {
    const { propFilters, onChange, eventName, entityType, idPrefix } = this.props;
    const { eventProps } = this.state;
    const propNameListId = 'proplist-' + (idPrefix || 'pf');

    return (
      <div className={styles.propSection}>
        {propFilters.length > 0 && <span className={styles.whereBar}>where</span>}
        {propFilters.map((pf, pi) => {
          const noVal = pf.op === 'is set' || pf.op === 'is not set';
          const isMulti = pf.op === 'in' || pf.op === 'not in';
          const valListId = 'propval-' + (idPrefix || 'pf') + '-' + pf.id;
          const sampleValues = eventProps.find((p) => p.name === pf.name)?.sample_values || [];
          return (
            <div key={pf.id} className={styles.propRow}>
              {pi > 0 && <span className={styles.andLbl}>and</span>}
              <Input
                size="sm"
                style={{ width: 150 }}
                list={propNameListId}
                placeholder="property name…"
                value={pf.name}
                onChange={(e) => onChange(propFilters.map((p) => (p.id === pf.id ? { ...p, name: e.target.value } : p)))}
              />
              <Select
                size="sm"
                style={{ width: 130 }}
                value={pf.op || 'equals'}
                options={PROPERTY_OPS.map((o) => ({ value: o, label: o }))}
                onChange={(val) => {
                  const nowMulti = val === 'in' || val === 'not in';
                  const nextVal = nowMulti
                    ? (Array.isArray(pf.val) ? pf.val : (pf.val ? [pf.val] : []))
                    : (Array.isArray(pf.val) ? (pf.val[0] || '') : pf.val);
                  onChange(propFilters.map((p) => (p.id === pf.id ? { ...p, op: val, val: nextVal } : p)));
                }}
              />
              {!noVal && (
                isMulti
                  ? (
                    <MultiValueInput
                      options={sampleValues}
                      value={Array.isArray(pf.val) ? pf.val : []}
                      onChange={(arr) => onChange(propFilters.map((p) => (p.id === pf.id ? { ...p, val: arr } : p)))}
                      placeholder="Add value…"
                    />
                  )
                  : (
                    <>
                      <Input
                        size="sm"
                        style={{ width: 150 }}
                        list={valListId}
                        placeholder="value…"
                        value={pf.val}
                        onChange={(e) => onChange(propFilters.map((p) => (p.id === pf.id ? { ...p, val: e.target.value } : p)))}
                      />
                      <datalist id={valListId}>
                        {sampleValues.map((v) => <option key={v} value={v} />)}
                      </datalist>
                    </>
                  )
              )}
              <button
                className={styles.propRemoveBtn}
                onClick={() => onChange(propFilters.filter((p) => p.id !== pf.id))}
              >
                <span className="material-symbols-rounded" style={{ fontSize: 12 }}>close</span>
              </button>
            </div>
          );
        })}

        <datalist id={propNameListId}>
          {eventProps.map((p) => <option key={p.name} value={p.name} />)}
        </datalist>

        {(eventName || entityType) && (
          <button
            className={styles.addPropBtn}
            onClick={() => onChange([...propFilters, { id: nextPropId(), name: '', op: 'equals', val: '' }])}
          >
            <span className="material-symbols-rounded" style={{ fontSize: 13 }}>add</span>
            Add property condition
          </button>
        )}
      </div>
    );
  }
}

export default PropertyFilters;
